"use strict";

require("core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routeParser = exports.routeMatcher = exports.routeHistory = exports["default"] = exports.Route = exports.Link = void 0;
var _routeMatcher2 = _interopRequireDefault(require("./route-matcher.js"));
var _routeParser2 = _interopRequireDefault(require("./route-parser.js"));
var _routeHistory2 = _interopRequireDefault(require("./route-history.js"));
var _link = _interopRequireDefault(require("./link.js"));
var _route = _interopRequireDefault(require("./route.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var routeMatcher = exports.routeMatcher = _routeMatcher2["default"];
var routeParser = exports.routeParser = _routeParser2["default"];
var routeHistory = exports.routeHistory = _routeHistory2["default"];
var Link = exports.Link = _link["default"];
var Route = exports.Route = _route["default"];
var _default = exports["default"] = {
  Link: Link,
  Route: Route,
  routeMatcher: routeMatcher,
  routeParser: routeParser,
  routeHistory: routeHistory
};
//# sourceMappingURL=index.js.map